import { Select } from "antd";
import clsx from 'clsx';
import React, { useEffect, useState } from "react";



export const SelectAtomic = ({ handleOptionsChange, optionsData, defaultValue, isToDisable, size, fullWidth, isModal, ...props }) => {
    const [selectedOption, setSelectedOption] = useState(defaultValue);

    useEffect(() => {
        try {
            // Se as opções mudarem e o defaultValue for um valor válido nas novas opções, atualize o selectedOptio
            if (optionsData?.some(option => option.value === defaultValue)) {
                setSelectedOption(defaultValue);
            }
            // Se o defaultValue não estiver nas opções, defina o selectedOption como null
            else {
                setSelectedOption(null);
            }
        } catch (error) {
            console.error('(SelectAtomic page) Error in useEffect when optionsData or defaultValue changed:', error);
            //reportError(error); // Send error report to backend
        }
    }, [optionsData, defaultValue]);
    return (select(handleOptionsChange, optionsData, defaultValue, isToDisable, size, fullWidth, selectedOption, setSelectedOption, isModal, props));
}

const select = (handleOptionsChange, optionsData, defaultValue, isToDisable, size, fullWidth, selectedOption, setSelectedOption, isModal, props) => {
    return (<Select
        listHeight={200}
        size={size ?? 'large'}
        bordered={!isModal}
        // placeholder={placeholder ?? 'Selecionar opção'}
        options={optionsData || []}
        onChange={(e, record) => { setSelectedOption(e); handleOptionsChange(e, record); }}
        disabled={isToDisable}
        value={selectedOption}
        // defaultValue={customDefaultValue}
        className={clsx('select-atomic', props?.className, fullWidth ? 'full-width' : '')}
        placeholder={props?.placeholder}
    >
        <Select.Option backgroundColor='transparent' value={null}>Selecionar...</Select.Option>
        {/* <Select.Option value={null}>Select...</Select.Option>  EN VERSION */}
    </Select>)
}